import React, { forwardRef } from 'react';
import {
  oneOf,
} from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Info } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';

const ProReferralTooltip = forwardRef(({ channel }, buttonRef) => {
  const tooltipContent = (
    <div className="sui-w-96" data-channel={`${channel}`}>
      <Typography variant="h5" weight="display">Why Choose Pro Referral?</Typography>
      <ul className="sui-list-disc sui-pl-5 sui-py-5">
        <li>Get connected to the pro that&apos;s right for you and your budget</li>
        <li>No mess - Pros clean up when finished</li>
        <li>Reduce stress and save time</li>
      </ul>
      <div>
        <Typography variant="h5" weight="display">What to Expect</Typography>
        <div>
          <p className="sui-pt-4">
            After completing your purchase, you&apos;ll be contacted
            by 1-3 Pro Referral pros, choose the pro that&apos;s best
            for your job and work with them directly to set up your appointment.
          </p>
          <p className="sui-pt-4">
            Please note that by continuing with this option, you consent to be
            contacted via phone by local pros, and you agree to the&nbsp;
            <a
              className="sui-underline"
              href="https://www.proreferral.com/about/legal/tos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pro Referral Terms of Service
            </a>
          </p>
        </div>
      </div>
    </div>
  );
  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className="sui-underline" ref={buttonRef}>
        <div className="sui-flex">
          <div>What to Expect</div>
          <div className="sui-ml-1 sui-mt-1"><Info size="small" /></div>
        </div>
      </button>
    </Tooltip>
  );
});

ProReferralTooltip.displayName = 'ProductAddOns-proReferral-tooltip';

ProReferralTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
};

ProReferralTooltip.defaultProps = {
  channel: 'desktop',
};

export { ProReferralTooltip };
